export default {
  init() {
    this.accordions();
  },

  accordions() {
    $('.accordion__toggle').on('click', function () {
      $(this).toggleClass('active');
      $(this).siblings('.accordion__content').slideToggle(300);
    });
  },
};
